<template>
    <div id="offline-support-form" class="h-100" :key="$i18n.locale">
        <div v-if="successfulSent">
            <a-result :title="$t('message.messageSent')">
                <template #icon>
                    <a-icon type="smile" twoToneColor="#eb2f96" :style="{ color: 'var(--primary_)' }" />
                </template>
                <template #extra>
                    <Button
                        borderRadius="99px"
                        :size="'large'"
                        @btnClicked="reconnect"
                        bg-color="var(--primary_)"
                        txt-color="var(--primary-text)"
                    >{{ $t("message.startChatAgain") }}
                    </Button
                    >
                </template>
            </a-result>
        </div>

        <div v-else>
            <form v-if="formVisible" autocomplete="off" @submit.prevent="submit">
                <md-field
                    :class="{
                        'md-invalid': getErrorItems().find((x) => x.field === $t('message.yourName')) !== undefined,
                    }">
                    <label>{{ $t("message.yourName") }}</label>

                    <md-input
                        v-model="offlineForm.fullname"
                        v-validate="'required'"
                        :name="$t('message.yourName')"
                        autofocus
                    />
                    <a-tooltip placement="topLeft" title="Ad Soyad alanı gereklidir">
                        <a-icon
                            v-if="getErrorItems().find((x) => x.field === $t('message.yourName')) !== undefined"
                            class="mr-2 aIcon"
                            type="exclamation-circle"
                            style="color: red; margin-top: 10px"
                        />
                    </a-tooltip>
                </md-field>
                <md-field
                    :class="{
                        'md-invalid': getErrorItems().find((x) => x.field === $t('message.email')) !== undefined,
                    }"
                    style="margin-top: 20px !important"
                >
                    <label>{{ $t("message.yourEmail") }}</label>

                    <md-input
                        v-model="offlineForm.email"
                        v-validate="'required|email'"
                        :name="$t('message.email')"
                        autocomplete="off"
                        type="text"
                    />
                    <a-tooltip placement="topLeft" title="Email alanı gereklidir">
                        <a-icon
                            v-if="getErrorItems().find((x) => x.field === $t('message.email')) !== undefined"
                            class="mr-2 aIcon"
                            type="exclamation-circle"
                            style="color: red; margin-top: 10px"
                        />
                    </a-tooltip>
                </md-field>
                <md-field
                    :class="{
                        'md-invalid': getErrorItems().find((x) => x.field === $t('message.phone')) !== undefined,
                    }"
                >
                    <label>{{ $t("message.phone") }}</label>
                    <md-input
                        v-model="offlineForm.phone"
                        v-validate="'required'"
                        :name="$t('message.phone')"
                        autocomplete="off"
                        type="tel"
                        v-mask="'(###) ### ## ##'"
                    />
                    <a-tooltip  placement="topLeft" title="Telefon alanı gereklidir">
                        <a-icon
                            v-if="getErrorItems().find((x) => x.field === $t('message.phone')) !== undefined"
                            class="mr-2 aIcon"
                            type="exclamation-circle"
                            style="color: red; margin-top: 10px"
                        />
                    </a-tooltip>
                </md-field>
                <md-field
                    :class="{
                        'md-invalid':
                            getErrorItems().find((x) => x.field === $t('message.writePlaceHolder')) !== undefined,
                    }"
                    class="textarea"
                >
                    <textarea
                        v-model="offlineForm.message"
                        v-validate="'required'"
                        :name="$t('message.writePlaceHolder')"
                        class="w-100 h-25 bg-transparent"
                        rows="5"
                        :placeholder="$t('message.messageTextPlaceHolder')"

                        style="border: none; resize: none;"
                    />
                    <a-tooltip  placement="topLeft" title="Mesaj alanı gereklidir">
                        <a-icon
                            v-if="getErrorItems().find((x) => x.field === $t('message.writePlaceHolder')) !== undefined"
                            class="mr-2 aIcon"
                            type="exclamation-circle"
                            style="color: red; margin-top: 10px"
                        />
                    </a-tooltip>
                </md-field>

                <!-- Yeni alan ekleyelim -->
                <md-field>
                    <label>{{ $t("message.preferredResponseMethod") }}</label>
                    <md-select v-model="offlineForm.returnType" name="returnType">
                        <md-option value="email">{{ $t("message.responseViaEmail") }}</md-option>
                        <md-option value="whatsapp">{{ $t("message.responseViaWhatsapp") }}</md-option>
                    </md-select>
                </md-field>

                <label class="d-flex w-100 justify-content-center ticket-buttons" style="border: 1px solid var(--form-input-border) !important;">
                    <a-button
                        :disabled="sending"
                        type="primary"
                        class="secondary btn-form btn-size"
                        @click="cancel"
                        style="margin-right: 5px"
                    >
                        {{ $t("message.cancel") }}
                        <a-icon v-if="sending" type="loading" />
                    </a-button>

                    <div class="flex-grow-1"></div>

                    <a-button
                        :disabled="sending"
                        type="primary btn-form btn-size"
                        @click="submit"
                        style="margin-left: 5px;"
                    >
                        {{ $t("message.sendMessage") }}
                        <a-icon v-if="sending" type="loading" />
                    </a-button>
                </label>
            </form>
            <div class="are-you-sure-ticket" v-else>
                <p v-html="contents.length > 0 && osrMessage.title" />
                <p v-html="contents.length > 0 && osrMessage.content" />
                <div class="buttons-wrapper">
                    <div
                        :style="{
                            color: 'var(--form-input-text)',
                            backgroundColor: 'transparent',
                            cursor: 'pointer',
                            padding: '10px',
                            textAlign: 'center',
                            borderRadius: '5px',
                            marginRight: '10px'
                        }"
                        @click="cancel"
                    >
                        {{ $t("message.cancel") }}
                    </div>
                    <div
                        :style="{
                            color: 'var(--form-input-text)',
                            backgroundColor: 'transparent',
                            cursor: 'pointer',
                            padding: '10px',
                            textAlign: 'center',
                            borderRadius: '5px',
                            border: '1px solid var(--form-input-text)'
                        }"
                        @click="formVisible = true"
                    >
                        {{ $t("message.sendMessage") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { createOfflineSupportRequest } from "../../api/offlineSupportRequest";
import log2 from "../../utils/log2";
import _ from "lodash";
import { sendSocketMessage } from "../../utils/socketStream";
import Button from "../../common/Button.vue";

import TextArea from "./svg/components/TextArea.vue";
import { sendMinimizeAction } from "../../utils/parentWindowConnection";

const log = log2("OfflineSupportRequestForm");
export default {
    name: "OfflineSupportRequestForm",
    components: { TextArea, Button },
    props: {
        ticketMode: Boolean,
    },
    data() {
        return {
            sending: false,
            successfulSent: false,
            formVisible: false,
            offlineForm: {
                email: undefined,
                fullname: undefined,
                phone: "",
                message: undefined,
                returnType: "email", // Varsayılan değer olarak email'i seçiyoruz
            },
            baseUrl: () => {
                if (document.currentScript) {
                    let _documentUrl = document.currentScript.src.split("/");
                    return _documentUrl[0] + "//" + _documentUrl[2] + "/";
                } else {
                    return "/";
                }
            },
            headerTitle: this.$t("message.createTicket"),
        };
    },
    computed: {
        ...mapState({
            visitorId: (state) => state.chat.visitorId,
            site: (state) => state.site.site,
            language: (state) => state.language.language,
            settings: (state) => state.setting.settings,
            contents: (state) => _.get(state.setting.settings, "osrLabels.languageContent", []) || [],
            currentHostUrl: (state) => state.app.currentHostUrl,
            offlineMode: (state) => state.setting.offlineMode,
            //visitorPreferredLang: (state) => _.get(state.chat.visitorInfo, "preferredLang", "tr"),
        }),
        ...mapGetters({
            reconnecting: "chat/reconnecting",
        }),
        osrMessage() {
            const contents = _.get(this, "contents", []) || [];
            const maybeContent =
                contents.length > 0 &&
                contents.find((content) => content.languageCode === _.get(this.language, "code"));
            return maybeContent || { title: this.$t("message.offline"), content: this.$t("message.noRepresentative") };
        },
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            resetConversation: "chat/resetConversation",
            setVisitorIsLoggedIn: "chat/setVisitorIsLoggedIn",
            setVisitorIsLogging: "chat/setVisitorIsLogging",
        }),
        ...mapMutations({
            changePageIndex: "app/CHANGE_PAGE",
        }),
        getErrorItems() {
            return _.get(this, "errors.items", []);
        },
        btnClickHandler(e) {},
        cancel() {
            if (!this.offlineMode) {
                this.$emit("change-to-ticket", false);
                this.changePageIndex(1);
                this.formVisible = false;
            } else {
                sendMinimizeAction();
            }
        },
        submit() {
            if (this.sending) return;
            this.$validator.validateAll().then((isSuccess) => {
                if (isSuccess) {
                    const payload = {
                        ...this.offlineForm,
                        phone: (this.offlineForm.phone || "")
                            .replaceAll("(", "")
                            .replaceAll(")", "")
                            .trim()
                            .replaceAll(" ", ""),
                        languageCode: this.language.code,
                        visitorId: this.visitorId,
                        returnType: this.offlineForm.returnType, // Yeni alanı payload'a ekliyoruz
                    };
                    log("osr submitting", payload);
                    this.sending = true;
                    this.$message.config({
                        top: "35px",
                    });
                    this.$message.loading({ content: this.$t("message.creatingTicketMsg"), key: "updatable" });
                    sendSocketMessage("visitor ticket-message", { ...payload, siteId: this.site._id });
                    createOfflineSupportRequest(payload).then((response) => {
                        log("osr was sent", this.successfulSent);
                        this.successfulSent = true;
                        this.sending = false;
                        this.$emit("change-to-ticket", false);
                        this.$message.success({
                            content: this.$t("message.createdTicketMsg"),
                            key: "updatable",
                            duration: 3,
                        });
                    });
                } else {
                    log("osr form is not valid", isSuccess);
                }
            });
        },
        reconnect() {
            this.successfulSent = false;
            this.formVisible = false;
            this.offlineForm.message = "";
            this.resetConversation();
            this.changePageIndex(1);
            this.setVisitorIsLoggedIn(false);
            this.setVisitorIsLogging(false);
        },
    },
    mounted() {
        if (this.ticketMode) {
            this.formVisible = true;
        }
        this.$emit("updateTitle", this.headerTitle);
    },

    updated() {},
    watch: {
        ticketMode(ticketModeEnabled) {
            log("ticketMode updated", {
                ticketMode: this.ticketMode,
                ticketModeEnabled,
                formVisible: this.formVisible,
            });
            if (ticketModeEnabled === false && this.formVisible) {
                this.formVisible = false;
            }
            if (this.ticketMode && !this.formVisible) {
                this.formVisible = true;
            }
        },
    },
};
</script>

<style lang="scss">
#login-form {
    color: var(--color7) !important;
}

.are-you-sure-ticket {
    color: var(--form-input-text) !important;
    width: 100%;

    .buttons-wrapper {
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        margin-top: 30px;
    }
}

input.userInputText::placeholder {
    color: var(--color8);
}

.ant-result {
    padding: 5px 12px;

    .ant-result-title {
        color: var(--color4);
        font-size: 18px !important;
    }

    p {
        font-size: 16px;
        margin-bottom: 15px;
    }
}

.ant-btn-primary {
    border: none !important;
}

.gap-30px {
    gap: 30px;
}

.btn-size {
    font-size: 14px !important;
}
</style>
<style lang="scss">
.ticket-buttons {
    width: 242px !important;
    margin: auto;
}

#text-area-error {
    bottom: 77px !important;
    z-index: 1;
}

.vti__input {
    background-color: transparent !important;
    color: var(--color4);
}

::placeholder {
    color: var(--color7);
}

.vti__dropdown-list {
    z-index: 9;
    -webkit-text-fill-color: black;
}

.vti__dropdown.open {
    background-color: transparent !important;
}

.vti__dropdown.open,
.vti__dropdown:hover {
    background-color: transparent !important;
}

.vti__selection .vti__country-code {
    margin-right: 2px;
}

.md-field.md-theme-default.md-has-value .md-input {
    -webkit-text-fill-color: var(--color4);
}
</style>



// WEBPACK FOOTER //
// src/components/V2/OfflineSupportRequestForm.vue